(function($) {
    /* Media Queries */
    window.breakpoint = 'mobile';
    window.breakpointChanged = false;
    var mediaQueriesElement = $( '<div class="mediaqueries" />' );
    $( 'body' ).after( mediaQueriesElement );
    function mapMediaQueries() {
        var lastBreakpoint = window.breakpoint;
        var i = parseInt( mediaQueriesElement.css( 'z-index' ) );
        switch( i ){
            case 1:
                window.breakpoint = 'tablet';
                break;
            case 2:
                window.breakpoint = 'desk';
                break;
            default:
                window.breakpoint = 'mobile';
                break;
        }
        window.breakpointChanged = ( lastBreakpoint != window.breakpoint );
    }
    mapMediaQueries();
    var initialBreakpoint = window.breakpoint;
    $(window).resize(function() {
        setTimeout(function() {
            mapMediaQueries();
        }, 500);
    });
})(jQuery); // Fully reference jQuery after this point.